<template>
  <div class="catalog-sort">
    <span v-if="screenWidth >= 992" class="catalog-sort__text">
      {{ result.messages.sort }}
    </span>
    <DefButtonSecondary v-if="screenWidth < 992" @click="handlerOpenModal">
      <svg>
        <use xlink:href="#svg-sort"></use>
      </svg>

      {{ getActiveName ?? result.messages.sort }}
    </DefButtonSecondary>
    <div v-else class="sort-items">
      <a
        v-for="item in result.items"
        :key="item.request"
        :href="item.request"
        class="sort-item"
        :class="{
          'sort-item_active': item.active || (!getActiveItem && item.sort === 'property_POPULAR'),
        }"
        rel="nofollow"
        @click.prevent="handlerChangeSort(item)"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
import useScreenWidth from '@use/useScreenWidth';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import useModal from '@use/useModal/useModal';
import CatalogSortModal from '@components/Catalog/CatalogSort/CatalogSortModal.vue';
import { replaceUrl } from '@/utils/location';

export default {
  name: 'CatalogSort',
  components: { DefButtonSecondary },
  props: ['result', 'isolated'],
  emits: ['changeSort'],
  data() {
    return {
      screenWidth: useScreenWidth(),
      modal: useModal(),
    };
  },
  computed: {
    getActiveItem() {
      return this.result.items.find((el) => el.active);
    },
    getActiveName() {
      return (
        this.getActiveItem?.name ||
        this.result.items.find((el) => el.sort === 'property_POPULAR')?.name
      );
    },
  },
  methods: {
    handlerChangeSort(item) {
      const fullPath = replaceUrl(item.request);

      this.$emit('changeSort', fullPath);
    },
    handlerOpenModal() {
      // isolated - сортировка вне каталога: данные и обработчик передаются в модалку
      const props = this.isolated
        ? { result: this.result, onChangeSort: (fullPath) => this.$emit('changeSort', fullPath) }
        : {};

      this.modal.show(CatalogSortModal, props, {});
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-sort {
  display: flex;
  position: relative;
  flex-grow: 1;
  @include point-md {
    white-space: nowrap;
    width: 100%;
  }
  &__text {
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    margin-right: 16px;
    padding: 4px 0;
  }
  &__item {
    &_active {
      color: var(--color-dark-grey);
    }
  }
  :deep(.def-button-secondary) {
    font-size: 14px;
    text-wrap: nowrap;
    height: 36px;
    padding: 0 14px;
    width: 100%;
    @include point-md {
      height: 42px;
      font-size: 16px;
    }
    svg {
      width: 18px;
      height: 18px;
      margin-right: 4px;
      @include point-md {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.sort-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
}
.sort-item {
  color: var(--main-blue);
  font-size: 16px;
  font-weight: 600;
  line-height: 125%;
  padding: 4px 8px;
  transition: 0.2s linear background-color, 0.2s linear color;
  &_active {
    color: #2a4962;
    background-color: #dbe5ee;
  }
}
</style>
